import store from "store";

export const SET_EVENT = "CURRENT_EVENT:SET_EVENT";

export const setEvent = (event) => {
	store.dispatch({type: SET_EVENT, event})
};

export const clear = () => {
	store.dispatch({type: SET_EVENT, event: null});
};

export default {
	setEvent, clear
}
